define([
	"dojo/_base/declare",
	"csi/core/Key",
	"csi/heading/_base",
	"csi/heading/Renderer",
	"csi/xml",
	"csi/utility/pathUtility",
	"./_ValueAttributeMixin"
], function(declare, Key, csiHeading, Renderer, xml,{pathCreate}, _ValueAttributeMixin) {

	/** @property {Object} _valueMap - Maps value types to the optional attributes on the SpecificationDatasheetItem */
	const _valueMap = {
		[xml.ATTR_REF]: "ValueLookupItem",
		[xml.ATTR_REFLIST]: "ValueLookupItemList",
		[xml.ATTR_BOOLEAN]: "ValueBoolean",
		[xml.ATTR_DOUBLE]: "ValueDouble",
		[xml.ATTR_INTEGER]: "ValueInt",
		[xml.ATTR_STRING]: "ValueString"
	};

	return declare([Renderer, _ValueAttributeMixin], {
		/**
		 * @override
		 * add dependency paths
		 */
		addRendererDependencyPaths(h, paths) {
			paths.push(pathCreate("Actual","Definition","ValueAttributeDefinition"));
			paths.push(pathCreate("ValueLookupItem"));
			paths.push(pathCreate("ValueLookupItemList"))
			this.inherited(arguments);
		 },

		/**
		 * @override
		 * Display different Value attributes under single "Value" column
		 */
		headingToHtml: function(ctx, h, refNode) {
			const vad = this._getValueAttributeNode(ctx);
			if (!vad) {
				return;
			}

			const id = _valueMap[vad.ValueType];
			const name = id + (vad.Format || "");
			const valueHeading = ctx.view.getHeading(new Key({
				id,
				name,
			}));

			csiHeading.getHeadingRenderer(ctx, valueHeading).headingToHtml(ctx, valueHeading, refNode);
		}
	});
});